'use strict';

function SlideMenu(props) {
  const menuArray = props.menuArray;
  const athleteNames = ["DUSTIN POIRIER", "DEREK LUNSFORD", "REGAN GRIMES"];
  const nonAthleteCollections = menuArray.filter(item => !athleteNames.some(name => item.caption.includes(name)));
  const athleteCollections = menuArray.filter(item => athleteNames.some(name => item.caption.includes(name)));
  React.useEffect(() => {
    return () => props.setWidt(0);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "slide-menu",
    style: {
      width: `${props.width}`
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "slide-menu-expandable menuContainer",
    style: {
      minWidth: `${props.minWidth}`
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "side-menu-inner-menu-caption-header"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: () => props.setWidt(0),
    className: "side-menu-inner-menu side-menu-inner-menu-caption"
  }, /*#__PURE__*/React.createElement("button", null, "<"), /*#__PURE__*/React.createElement("h2", null, "GO BACK")), /*#__PURE__*/React.createElement("div", {
    className: "side-menu-inner-menu inner-menu-static-caption"
  }, /*#__PURE__*/React.createElement("h2", null, "SHOP BY ", props.caption))), /*#__PURE__*/React.createElement("ul", null, nonAthleteCollections.map((x, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, /*#__PURE__*/React.createElement(SlideMenuCard, {
    children: x.children,
    caption: x.caption,
    link: x.link,
    image: x.image,
    typeOfCard: x.typeOfCard,
    ztyle: x.ztyle,
    h2ztyle: x.h2ztyle
  })))), athleteCollections.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "side-menu-inner-menu inner-menu-static-caption"
  }, /*#__PURE__*/React.createElement("h2", null, "SHOP BY ATHLETE")), /*#__PURE__*/React.createElement("ul", null, athleteCollections.map((item, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, /*#__PURE__*/React.createElement(SlideMenuCard, {
    children: item.children,
    caption: item.caption,
    link: item.link,
    image: item.image,
    typeOfCard: item.typeOfCard,
    ztyle: item.ztyle,
    h2ztyle: item.h2ztyle
  })))))));
}
function SlideMenuCard(props) {
  const caption = props.caption;
  const width = props.width;
  const typeOfCard = props.typeOfCard;
  const children = props.children;
  const link = props.link;
  const image = props.image;
  const [slideMenuInner, setslideMenuInner] = React.useState('0');
  if (typeOfCard == 'custom') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children.length > 0 ? /*#__PURE__*/React.createElement(SlideMenu, {
      caption: caption,
      width: slideMenuInner,
      setWidt: setslideMenuInner,
      menuArray: children,
      minWidth: props.minWidth
    }) : null, /*#__PURE__*/React.createElement("a", {
      className: "side-menu-button",
      onClick: () => {
        link.length > 0 ? location.href = link : setslideMenuInner(width);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "card side-menu-card custom-card",
      style: props.ztyle
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-caption"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "slide-menu-custom-card-h2",
      style: props.h2ztyle
    }, caption)), image ? /*#__PURE__*/React.createElement("img", {
      height: "110px",
      className: "",
      src: image
    }) : null))));
  } else if (typeOfCard == 'inner') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children.length > 0 ? /*#__PURE__*/React.createElement(SlideMenu, {
      width: slideMenuInner,
      setWidt: setslideMenuInner,
      menuArray: children,
      minWidth: props.minWidth
    }) : null, /*#__PURE__*/React.createElement("a", {
      className: "side-menu-inner-button",
      onClick: () => {
        link.length > 0 ? location.href = link : setslideMenuInner(width);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "card slide-menu-inner-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-body"
    }, /*#__PURE__*/React.createElement("img", {
      height: "60px",
      className: "",
      src: image
    }), /*#__PURE__*/React.createElement("div", {
      className: "card-caption slide-menu-inner-card-caption"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "slide-menu-inner-card-h2"
    }, caption), /*#__PURE__*/React.createElement("span", null, " >"))))));
  } else if (typeOfCard == 'regular') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children.length > 0 && width != "0" ? /*#__PURE__*/React.createElement(SlideMenu, {
      caption: caption,
      width: slideMenuInner,
      setWidt: setslideMenuInner,
      menuArray: children,
      minWidth: props.minWidth
    }) : null, /*#__PURE__*/React.createElement("a", {
      className: "side-menu-button",
      onClick: () => {
        link.length > 0 ? location.href = link : setslideMenuInner(width);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "card regular-card side-menu-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-caption slide-menu-card-caption"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "slide-menu-regular-card-h2"
    }, caption), children.length > 0 ? /*#__PURE__*/React.createElement("p", null, "SHOW MORE ", /*#__PURE__*/React.createElement("span", null, ">")) : null), /*#__PURE__*/React.createElement("img", {
      height: "110px",
      id: "t1t2t3",
      src: image
    })))));
  }
  ;
}
function ReactMenu(props) {
  const menVideo = "https://cdn.shopify.com/videos/c/o/v/5595dbe198f44eb4a61015111338d9d9.mp4";
  const womenVideo = "https://cdn.shopify.com/videos/c/o/v/8eba22a136d44c2c83a1d954865b299b.mp4";
  const width = props.width;
  const menRef = React.useRef(null);
  const womenRef = React.useRef(null);
  const [video, setVideo] = React.useState(menVideo);
  const [videoBackOpacity, setVideoBackOpacity] = React.useState("0");
  const [display, setDisplay] = React.useState("none");
  const [menuItems, setMenuItems] = React.useState({});
  const [menButtonDisabled, setMenButtonDisabled] = React.useState(true);
  const [womenButtonDisabled, setWomenButtonDisabled] = React.useState(true);
  function switchVideo() {
    setVideoBackOpacity("1");
    setTimeout(() => {
      video == menVideo ? setVideo(womenVideo) : setVideo(menVideo);
      setVideoBackOpacity("0");
    }, "500");
    document.querySelector(".mobileVideo").play();
  }
  React.useEffect(() => {
    menRef.current.className.includes("active") ? setVideo(menVideo) : setVideo(womenVideo);
    fetch(props.menuItems).then(response => response.json()).then(data => setMenuItems(data));
  }, []);
  React.useEffect(() => {
    width == 0 ? setDisplay("none") : setDisplay("unset");
    if (menRef.current.className.includes("active")) {
      setMenButtonDisabled(true);
      setWomenButtonDisabled(false);
    } else {
      setMenButtonDisabled(false);
      setWomenButtonDisabled(true);
    }
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("nav", null, /*#__PURE__*/React.createElement("video", {
    src: `${video}`,
    style: {
      "display": display
    },
    className: "mobileVideo ",
    autoPlay: true,
    muted: true,
    loop: true,
    playsInline: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "mobileVideo2",
    style: {
      "opacity": videoBackOpacity,
      "display": display
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "nav nav-tabs",
    id: "nav-tab",
    role: "tablist"
  }, /*#__PURE__*/React.createElement("button", {
    ref: menRef,
    disabled: menButtonDisabled,
    onClick: switchVideo,
    className: `nav-link slide-menu-tab  ${window.location.pathname.includes('women') ? "" : "active"}`,
    "data-bs-toggle": "tab",
    "data-bs-target": "#nav-mens",
    type: "button",
    role: "tab",
    "aria-controls": "nav-mens",
    "aria-selected": "true"
  }, "MEN"), /*#__PURE__*/React.createElement("button", {
    ref: womenRef,
    disabled: womenButtonDisabled,
    onClick: switchVideo,
    className: `nav-link slide-menu-tab ${window.location.pathname.includes('women') ? "active" : ""}`,
    "data-bs-toggle": "tab",
    "data-bs-target": "#nav-womens",
    type: "button",
    role: "tab",
    "aria-controls": "nav-womens",
    "aria-selected": "false"
  }, "WOMEN")), /*#__PURE__*/React.createElement("div", {
    className: "tab-content",
    id: "nav-tabContent"
  }, /*#__PURE__*/React.createElement("div", {
    className: `tab-pane ${window.location.pathname.includes('women') ? "" : "active show"}`,
    id: "nav-mens",
    role: "tabpanel",
    "aria-labelledby": "nav-mens-tab",
    tabIndex: "0"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "slide-menu-items menuContainer"
  }, /*#__PURE__*/React.createElement("a", {
    className: "cardTitle",
    href: "/pages/mens"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card regular-card side-menu-top-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "slide-menu-top-button-caption"
  }, "STOREFRONT"), " "))), menuItems.men && menuItems.men.map((x, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, /*#__PURE__*/React.createElement(SlideMenuCard, {
    children: x.children,
    caption: x.caption,
    link: x.link,
    image: x.image,
    typeOfCard: x.typeOfCard,
    ztyle: x.ztyle,
    width: width,
    minWidth: props.minWidth,
    h2ztyle: x.h2ztyle
  }))))), /*#__PURE__*/React.createElement("div", {
    className: `tab-pane ${window.location.pathname.includes('women') ? "active show" : ""}`,
    id: "nav-womens",
    role: "tabpanel",
    "aria-labelledby": "nav-profile-tab",
    tabIndex: "0"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "slide-menu-items menuContainer"
  }, /*#__PURE__*/React.createElement("a", {
    className: "cardTitle",
    href: "/pages/womens"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card regular-card side-menu-top-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "slide-menu-top-button-caption"
  }, "STOREFRONT")))), menuItems.women && menuItems.women.map((x, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, /*#__PURE__*/React.createElement(SlideMenuCard, {
    children: x.children,
    caption: x.caption,
    link: x.link,
    image: x.image,
    typeOfCard: x.typeOfCard,
    ztyle: x.ztyle,
    width: width,
    minWidth: props.minWidth,
    h2ztyle: x.h2ztyle
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "side-menu-bottom-icons"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/pages/rewards"
  }, /*#__PURE__*/React.createElement("div", {
    className: "side-menu-bottom-icon"
  }, /*#__PURE__*/React.createElement("img", {
    className: "bottom",
    width: "75px",
    src: "https://cdn.shopify.com/s/files/1/2665/0346/files/logo_3b57c5cc-6041-4d5a-ba59-4132ad820229.png?v=1680717045"
  }), /*#__PURE__*/React.createElement("p", {
    className: "side-menu-bottom-icon-caption"
  }, "Rewards"))), /*#__PURE__*/React.createElement("a", {
    href: "/account"
  }, /*#__PURE__*/React.createElement("div", {
    className: "side-menu-bottom-icon"
  }, /*#__PURE__*/React.createElement("img", {
    width: "75px",
    src: "https://cdn.shopify.com/s/files/1/2665/0346/files/account.png?v=1680290662"
  }), /*#__PURE__*/React.createElement("p", {
    className: "side-menu-bottom-icon-caption"
  }, "Account"))), /*#__PURE__*/React.createElement("a", {
    href: "/pages/text-us"
  }, /*#__PURE__*/React.createElement("div", {
    className: "side-menu-bottom-icon"
  }, /*#__PURE__*/React.createElement("img", {
    width: "75px",
    src: "https://cdn.shopify.com/s/files/1/2665/0346/files/icons8-red-carpet-100.png?v=1680710278"
  }), /*#__PURE__*/React.createElement("p", {
    className: "side-menu-bottom-icon-caption"
  }, "VIP club"))), /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: "https://helpdesk.tlfapparel.com/hc/en-us"
  }, /*#__PURE__*/React.createElement("div", {
    className: "side-menu-bottom-icon"
  }, /*#__PURE__*/React.createElement("img", {
    width: "75px",
    src: "https://cdn.shopify.com/s/files/1/2665/0346/files/icons8-help-100.png?v=1680286286"
  }), /*#__PURE__*/React.createElement("p", {
    className: "side-menu-bottom-icon-caption"
  }, "Help Center"))), /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: "https://tlfapparel.loopreturns.com/#/"
  }, /*#__PURE__*/React.createElement("div", {
    className: "side-menu-bottom-icon"
  }, /*#__PURE__*/React.createElement("img", {
    width: "75px",
    src: "https://cdn.shopify.com/s/files/1/2665/0346/files/return-box.png?v=1680290514"
  }), /*#__PURE__*/React.createElement("p", {
    className: "side-menu-bottom-icon-caption"
  }, "Returns & Refunds"))), /*#__PURE__*/React.createElement("a", {
    href: "/pages/order-lookup"
  }, /*#__PURE__*/React.createElement("div", {
    className: "side-menu-bottom-icon"
  }, /*#__PURE__*/React.createElement("img", {
    width: "75px",
    src: "https://cdn.shopify.com/s/files/1/2665/0346/files/icons8-in-transit-100.png?v=1680287197"
  }), /*#__PURE__*/React.createElement("p", {
    className: "side-menu-bottom-icon-caption"
  }, "Order Status"))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    href: "/"
  }, /*#__PURE__*/React.createElement("img", {
    className: "logo",
    width: "250px",
    src: "https://cdn.shopify.com/s/files/1/2665/0346/files/new-logo-trasparent-bg.png?v=1680718328",
    alt: "logo"
  }))));
}
;
